import { motion } from 'framer-motion'
import './WhoCanUse.css'

export default function WhoCanUse() {
    const userTypes = [
        {
            title: 'Professional Traders',
            description: 'Seize fleeting arbitrage windows with institutional-speed execution. Multi-exchange settlement in seconds, not hours—giving you the competitive edge to capture spreads others miss.',
            icon: '📈'
        },
        {
            title: 'Freelancers & Creators',
            description: 'Get paid with atomic settlement, anywhere in the world. Bypass payment processors and their 5-day holds. Your USDT arrives the moment your client sends it—zero intermediaries, zero delays.',
            icon: '💼'
        },
        {
            title: 'Enterprise & Treasury',
            description: 'Move millions with confidence. Bank-grade security protocols, comprehensive audit trails, and dedicated API access. Scale your USDT operations without scaling your risk exposure.',
            icon: '🏢'
        },
        {
            title: 'DeFi Power Users',
            description: 'Maximize yield farming and liquidity provision strategies. Atomic capital reallocation between protocols, settlement routing compatibility, and MEV-resistant transaction execution.',
            icon: '⚡'
        },
        {
            title: 'Global Commerce',
            description: 'Unlock borderless payments without forex friction. 24/7 settlement across 150+ countries, no SWIFT delays, no correspondent bank fees. True financial sovereignty for your business.',
            icon: '🌍'
        },
        {
            title: 'First-Time Users',
            description: 'Start your crypto journey with confidence. Intuitive one-click interface, guided transaction flow, and responsive support. Your first USDT transfer, seamlessly executed in under 60 seconds.',
            icon: '🚀'
        }
    ]

    return (
        <section className="who-section">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="section-title">
                        Who Uses <span className="text-neon">TetherStream Protocol</span>?
                    </h2>
                    <p className="section-subtitle">
                        Trusted by privacy-conscious individuals and high-volume institutions alike.
                        From your first transaction to your millionth.
                    </p>
                </motion.div>

                <div className="user-types-grid">
                    {userTypes.map((user, index) => (
                        <motion.div
                            key={index}
                            className="user-card glass"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            whileHover={{
                                scale: 1.05,
                                rotateY: 5,
                                rotateX: 5
                            }}
                        >
                            <div className="user-icon">{user.icon}</div>
                            <h3 className="user-title">{user.title}</h3>
                            <p className="user-description">{user.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}
